export const slug = "import-csv";
export const title = "Import CSV";
export const section = "Administration";
export const content = `
# Import CSV

The CSV Import tool lets you bulk-load client records from a spreadsheet, saving manual data entry when onboarding a large group.

## Accepted File Format

Your CSV must use **UTF-8 encoding** and include a header row. The following columns are supported:

| Column | Required | Notes |
|--------|----------|-------|
| \`first_name\` | Yes | |
| \`last_name\` | Yes | |
| \`address\` | Yes | Full street address |
| \`city\` | No | Defaults to your configured city |
| \`zip\` | No | |
| \`phone\` | No | 10-digit US format |
| \`email\` | No | |
| \`household_size\` | No | Defaults to 1 |

Extra columns are ignored. Column names are case-insensitive.

## Field Mapping

If your column names differ from the expected names, use the **Field Mapping** step after uploading. Drag columns from your file to the matching system fields.

## What Happens After Import

1. New records are created for rows that do not match any existing client.
2. Rows that match an existing client (by name + address or phone) are flagged as **potential duplicates** for review — they are not automatically merged.
3. A summary screen shows how many records were created, how many were skipped, and any rows that had errors.

## Member Duplicate Detection

If two rows in your import file have the same name and address, the import will flag them and import only the first occurrence. The flagged duplicates appear in the Compare Clients queue for manual review.

## Tips

- Test with a small batch (10–20 rows) before importing a large file.
- The import is **not reversible** in bulk — if you need to undo an import, contact your system administrator.
- All imported records are marked with an "Imported" tag in the audit log so you can filter for them later.
`;
